import * as React from "react";
const SvgFiRrSquareB = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-square-b_svg__a)">
      <path
        fill="#062147"
        d="M15.331 11.213A4 4 0 0 0 16 9.001c0-2.206-1.794-4-4-4H9.5c-1.93 0-3.5 1.57-3.5 3.5v7c0 1.929 1.57 3.5 3.5 3.5h4.545c2.181 0 3.955-1.774 3.955-4.03 0-1.062-.41-2.06-1.155-2.808a3.94 3.94 0 0 0-1.514-.95M8 8.5C8 7.673 8.673 7 9.5 7H12c1.103 0 2 .897 2 2s-.897 2-2 2H8zm6.045 8.501H9.5c-.827 0-1.5-.674-1.5-1.5v-2.5h6.048c.521 0 1.011.203 1.379.573.369.371.573.867.573 1.472a1.957 1.957 0 0 1-1.955 1.955M19 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m3 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-square-b_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSquareB;
